<template>
    <div class="offer-sent-container">
        <p class="title">All set!</p>
        <div class="last-things">
            <p class="title">A few last things before you go</p>
            <p class="details">
                Enhance your visibility by adding socials, a bio and your desired payout for
                future bookings. Adding this info will make your profile publicly available.
            </p>
        </div>
        <div class="messages">
            <div v-for="message in messages" :key="message.text" class="message">
                <img :src="message.icon" alt="check-mark" />
                <p class="message-text">{{ message.text }}</p>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'OfferSent',
        props: {
            userData: {
                type: Object,
                required: true
            },
            opportunityInfo: {
                type: Object,
                required: true
            }
        },
        computed: {
            messages() {
                return [
                    {
                        icon: '/images/icons/checkmark-grey.svg',
                        text: `You artist profile for ${this.userData.artistInfo.band_name} is set up`
                    },
                    {
                        icon: '/images/icons/checkmark-grey.svg',
                        text: `Your offer has been sent to ${this.opportunityInfo.venue_name}`
                    }
                ]
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .offer-sent-container {
        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }

        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 40px;

        .title {
            color: #dedede;
            @include base-font-24;
            font-weight: 600;
            line-height: 28px;
        }

        .last-things {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;

            .title {
                color: #dedede;
                @include base-font-20;
                font-weight: 600;
                line-height: 24px;
                text-wrap: wrap;
            }
            .details {
                color: #8b8b8b;
                @include base-font-16;
                font-weight: 400;
                line-height: 24px;
                text-wrap: wrap;
            }
        }
        .messages {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            gap: 8px;

            .message {
                width: 100%;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-start;
                gap: 8px;

                img {
                    width: 24px;
                    height: 24px;
                    object-fit: cover;
                }
                .message-text {
                    color: var(--Neutral-400, #8b8b8b);
                    @include base-font-16;
                    font-weight: 400;
                    line-height: 24px;
                    text-wrap: wrap;
                }
            }
        }
    }
</style>
